module.exports = __webpack_public_path__ + "static/img/reproductive_organ.db2ee44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/reproductive_organ.png
// module id = qi5e
// module chunks = 1